package dev.valvassori.minesweeper.helpers

fun nextAnonUser(): String =
    "anonuser-${currentMillis().toLong().div(1000).toString().takeLast(5)}"
